<template>
	<preloader :overlay="appModel.preloader" />
	 
	<!-- Main Wrapper Start -->
	<div id="scroll-container" class="main-wrapper">
		<header-menu />

		<router-view/>
		
	</div>
	<!-- Main Wrapper End -->

	<!-- Back To Top Start -->
	<a href="#main-wrapper" id="backto-top" class="back-to-top"><i class="fas fa-angle-up"></i></a>
	

	<!-- Mobile Menu Start -->
	<div class="mobile-nav__wrapper">
		<div class="mobile-nav__overlay mobile-nav__toggler"></div>
		<div class="mobile-nav__content">
			<span class="mobile-nav__close mobile-nav__toggler"><i class="fa fa-times"></i></span>
			<div class="logo-box">
				<router-link :to="{path: '/'}" aria-label="logo image">
					<img src="/assets/media/mobile-logo.png" alt="">
				</router-link>
			</div>
			<div class="mobile-nav__container"></div>
			<ul class="mobile-nav__contact list-unstyled">
				<li>
					<i class="fas fa-envelope"></i>
					<a href="mailto:intermagtech@mail.kz">intermagtech@mail.kz</a>
				</li>
				<li>
					<i class="fa fa-phone-alt"></i>
					<a href="tel:+12345678">+7 800 000 0000</a>
				</li>
			</ul>
			<div class="mobile-nav__social">
				<a href="#"><i class="fa-brands fa-x-twitter"></i></a>
				<a href="#"><i class="fab fa-facebook"></i></a>
				<a href="#"><i class="fab fa-instagram"></i></a>
			</div>
		</div>
	</div>
	<!-- Mobile Menu End -->

	<!-- Modal -->
	<div class="modal fade" id="productQuickView" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-body">
					<div class="shop-detail">
						<div class="detail-wrapper">
							<div class="row">
								<div class="col-lg-6">
									<div class="quick-image-box">
										<img src="/assets/media/products/quick-view-image.png" alt="">
									</div>
								</div>
								<div class="col-lg-6">
									<div class="product-text-container bg-white br-20">
										<div class="close-content text-end">
											<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
										</div>
										<h3 class="fw-600 mb-16">Nexus Mobile Pro 256GB</h3>
										<div class="d-flex align-items-center flex-wrap gap-16 mb-24">
											<h5 class="color-sec">★★★★<span class="light-gray">★</span>&nbsp;&nbsp;<span
													class="text-16 fw-400 dark-black">(02 Reviews)</span></h5>
											<div class="vr-line vr-line-2"></div>
											<p class="light-gray">Brand: <span class="color-primary">Beast</span></p>
										</div>
										<div class="d-flex align-items-center gap-16 mb-24">
											<p class="light-gray text-decoration-line-through">$450.00</p>
											<h5>$400.00</h5>
											<span class="label white">-12%</span>
										</div>
										<p class="light-gray mb-24">
											Lorem ipsum dolor sit amet consectetur. Purus nulla nec in ac malesuada et nisi ipsum. Massa scelerisque...
										</p>
										<div class="hr-line mb-24"></div>
										<div class="function-bar mb-16">
											<div class="quantity quantity-wrap">
												<div class="input-area quantity-wrap">
													<input class="decrement" type="button" value="-">
													<input type="text" name="quantity" value="1" maxlength="2" size="1"
														class="number">
													<input class="increment" type="button" value="+">
												</div>
											</div>
											<div class="cart-btn w-100">
												<a href="cart.html" class="cus-btn-2 w-100">ADD TO CART</a>
											</div>
										</div>
										<div class="hr-line mb-24"></div>
										<div class="d-flex align-items-center gap-16 mb-16">
											<h6>Category:</h6>
											<p class="light-gray">Mobile Phone , Android , Flagship</p>
										</div>
										<div class="d-flex align-items-center gap-16 mb-16">
											<h6>Tags:</h6>
											<p class="light-gray">5G Compatible , <span>256GB Storage , </span> Student Phone</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- Modal -->
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Preloader from '@/components/Preloader';
import HeaderMenu from '@/components/HeaderMenu.vue';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech'});
	},
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	async mounted(){
		let ret;
		
		ret = await this.appModel.doGetCoupons();
		if(ret.success) {
			this.appModel.coupons = ret.list;
		}
		
		ret = await this.appModel.doGetProductsCategories();
		if(ret.success) {
			this.appModel.productsCategories = ret.list;
		}
		
		setTimeout(() => {
			this.appModel.preloader = false;
		}, 1000);
	},
	components: {
		Preloader,
		HeaderMenu,
	},
}
</script>